import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SearchAddress } from '../../models/searchAddress';

@Injectable()
export class AddressService {
  constructor(private _authHttp: HttpClient) {}

  public getCityState(country: string, postalCode: string): Observable<any> {
    if (country && country.length && postalCode && postalCode.length) {
      const url = `${environment.baseAPIUrl}/Addresses/${country}/${postalCode}`;
      return this._authHttp.get<SearchAddress[]>(url).pipe(
        map(addresses => {
          if (addresses.length) {
            const address = addresses[0];
            const cityState = Object();
            cityState.state = address.countrySubdivision
              ? address.countrySubdivision
              : null;
            cityState.city = address.municipality ? address.municipality : null;

            return cityState;
          }
        }),
        catchError((err: any) => of({ city: '', state: '' }))
      );
    } else {
      return of({ city: '', state: '' });
    }
  }
}
